export interface OpacityAndColor {
    opacity: number;
    color: string;
}

export const probabilityToOpacityAndColor = (probability: number): OpacityAndColor => {
    // Min opacity of 45 and max of 85

    if (probability < 40) {
        const opacity = 0.45 + (40 - probability) / 100;
        return { opacity: opacity, color: 'var(--blue-x40)' };
    }

    if (probability < 60) {
        return { opacity: 0.5, color: 'var(--purple-x40)' };
    }

    const opacity = 0.45 + (probability - 60) / 100;
    return { opacity: opacity, color: 'var(--red-x40)' };
};
